module.exports = __webpack_public_path__ + "img/banner-hol.1db8ea44.jpg";